import { Grid } from '@mui/material';
import ButtonImage from 'assets/icons/form-builder/forms/elements/basics/button.svg';
import EmailImage from 'assets/icons/form-builder/forms/elements/basics/email.svg';
import LogoImage from 'assets/icons/form-builder/forms/elements/basics/logo.svg';
import PhoneImage from 'assets/icons/form-builder/forms/elements/basics/phone.svg';
import QuestionsImage from 'assets/icons/form-builder/forms/elements/basics/questions.svg';
import TextImage from 'assets/icons/form-builder/forms/elements/basics/text.svg';
import { useIntl } from 'react-intl';
import NewComponentItem from './NewComponentItem';

const Basics = ({ handleDragStart }: any) => {
  const intl = useIntl();
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Logo' })}
          type="Logo"
          icon={<img src={LogoImage} alt="logo" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Text' })}
          type="Text"
          icon={<img src={TextImage} alt="text" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Button' })}
          type="Button"
          icon={<img src={ButtonImage} alt="button" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Questions' })}
          type="Questionnaire"
          icon={<img src={QuestionsImage} alt="questions" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Email' })}
          type="Email Field"
          icon={<img src={EmailImage} alt="email" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Phone' })}
          type="Phone Number"
          icon={<img src={PhoneImage} alt="phone number" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
    </Grid>
  );
};

export default Basics;
